import React from 'react';

// Components
import WpDataTable, { SortDirection } from 'Wpds/components/table/WpDataTable';
import UserCell from './UserCell';

type Props = {
  coachingSummary;
};

const ExecutiveCoachingSummary = ({ coachingSummary }: Props) => {
  if (!coachingSummary) return null;

  return (
    <WpDataTable
      columns={[
        {
          name: 'Name',
          initialSort: SortDirection.ASC,
          columnGroup: 'User',
          component: ({ row }) => UserCell(row),
        },
        { name: 'Department', selector: 'user_department', columnGroup: 'User' },
        { name: 'Role', selector: 'user_role', columnGroup: 'User' },
        { name: 'Given', selector: 'feedback_given', columnGroup: 'Feedback' },
        { name: 'Received', selector: 'feedback_received', columnGroup: 'Feedback' },
        { name: 'Given', selector: 'kudos_given', columnGroup: 'Kudos' },
        { name: 'Received', selector: 'kudos_received', columnGroup: 'Kudos' },
        { name: 'Created', selector: 'goals_created', columnGroup: 'Goals' },
        { name: 'Completed', selector: 'goals_completed', columnGroup: 'Goals' },
        { name: 'Open', selector: 'goals_open', columnGroup: 'Goals' },
      ]}
      rows={coachingSummary}
    />
  );
};

export default ExecutiveCoachingSummary;
